module.exports = __webpack_public_path__ + "static/media/MT.dac11acf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/MT.svg
// module id = 2215
// module chunks = 7